// Conversion tracking utilities
// Replace with actual Google Ads / GA4 event calls once tags are installed

export type ConversionEvent =
  | "form_submission"
  | "bill_upload"
  | "document_upload"
  | "contact_form"
  | "phone_call"
  | "qualified_lead"
  | "closed_deal";

export function trackConversion(event: ConversionEvent, data?: Record<string, string>) {
  // GA4 event
  if (typeof window !== "undefined" && (window as any).gtag) {
    (window as any).gtag("event", event, {
      event_category: "lead_generation",
      ...data,
    });
  }

  // Google Ads conversion (replace with actual conversion IDs)
  const conversionIds: Record<ConversionEvent, string> = {
    form_submission: "AW-XXXXXXXXX/form_submit",
    bill_upload: "AW-XXXXXXXXX/bill_upload",
    document_upload: "AW-XXXXXXXXX/document_upload",
    contact_form: "AW-XXXXXXXXX/contact_form",
    phone_call: "AW-XXXXXXXXX/phone_call",
    qualified_lead: "AW-XXXXXXXXX/qualified_lead",
    closed_deal: "AW-XXXXXXXXX/closed_deal",
  };

  if (typeof window !== "undefined" && (window as any).gtag) {
    (window as any).gtag("event", "conversion", {
      send_to: conversionIds[event],
      ...data,
    });
  }

  console.log(`[Conversion] ${event}`, data);
}
